import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useNavigate } from '@reach/router';
import Layout from '../../components/Layout';
import ResourceTemplate from '../../components/Resource';
import { Spinner } from 'reactstrap';
import Text from '../../components/Medata/search/civil/components/Text';
import Tags from '../../components/Medata/search/civil/components/Tags';
import TopicIcon from '../../components/Medata/search/civil/templates/TopicIcon';
import Breadcrumb from '../../components/Medata/breadcrumb';
import { countBy } from 'lodash';
import { Share } from '../../components/Medata/search/civil/components/Share';
import FileDownload from '../../components/Medata/search/civil/components/FileDownload';
import FileDownloadMultiFormat from '../../components/Medata/search/civil/components/FileDownloadMultiFormat';
import '../../components/Medata/search/civil/components/FileDownloadMultiFormat/styles.scss';
import Subscription from '../../components/Medata/search/civil/components/Subscription';
import { MedataContext } from '../../ContexMedata';
import HomeSurvey from '../../components/Medata/home/home-survey';


const Dataset = ({ id, location }) => {
  const { state } = location;
  const [item, setItem] = useState(state && state.dataset ? state.dataset : {});
  const [hasWindow, checkForWindow] = useState(false);
  const [display, setDisplay] = useState('block');
  const [iconCardClass, setIconCardClass] = useState('fa-chevron-up');
  const [spanText, setSpanText] = useState('Cerrar detalles');
  const [spanColor, setSpanColor] = useState('#FA8D2D');
  const url = window.location.href
  const [views, setViews] = useState('')
  const [downloads, setDownloads] = useState('')
  const { datasetDonwloads, setDatasetDonwloads } = useContext(MedataContext);


  useEffect(() => {
    async function getViews() {
      // Registrar la visita e incrementar el contador EN EL SERVIDOR con un solo
      // POST al endpoint custom (medata_stats). Antes esto se hacía con un GET +
      // PATCH a JSON:API desde el navegador, con credenciales de escritura
      // embebidas en el bundle (riesgo de seguridad) y que además se colgaban
      // hasta timeout, bloqueando la carga del dataset.
      try {
        const { data } = await axios.post(`/api/dataset/${id}/visita`);
        setViews(data.visitas != null ? data.visitas : 1);
        setDownloads(data.descargas != null ? data.descargas : 0);
        setDatasetDonwloads(data.descargas != null ? data.descargas : 0);
      } catch (error) {
        // No bloquear la carga del dataset si el conteo falla.
        console.log('No se pudo registrar la visita:', error.message);
      }
    }
    getViews();
  }, [])

  useEffect(() => {
    if (window !== undefined) {
      checkForWindow(true);
    }
    async function getItem() {
      // Antes esto iba al metastore de DKAN
      // (/metastore/schemas/dataset/items/{id}?show-reference-ids=true), que con
      // el volumen actual del catálogo se cuelga (>60 s -> 504) al resolver en
      // cascada publisher/theme/keyword/distribution, dejando la ficha cargando
      // para siempre. El endpoint custom /api/dataset-fast/{id} (medata_stats)
      // devuelve el MISMO formato (referencias ya resueltas como {identifier,
      // data}) leyendo node__field_json_metadata directo, en ms.
      const { data } = await axios.get(`/api/dataset-fast/${id}`);
      setItem(data);
    }
    if (!state || !state.dataset) {
      getItem();
    }
  }, [id, state]);

  const orgName =
    'publisher' in item && item.publisher ? item.publisher.data.name : '';
  const tag = 'keyword' in item ? item.keyword : [];
  const theme = 'theme' in item ? item.theme : [];

  function getPeriodicity(code) {
    if (!code) {
      return null;
    } else {
      let periodicityName = '';
      switch (code) {
        case 'R/P4Y':
          periodicityName = 'Cuatrienal';
          break;
        case 'R/P10Y':
          periodicityName = 'Decenal';
          break;
        case 'R/P1Y':
          periodicityName = 'Anual';
          break;
        case 'R/P2M':
          periodicityName = 'Bimestral';
          break;
        case 'R/P3.5D':
          periodicityName = 'Bisemanal';
          break;
        case 'R/P1D':
          periodicityName = 'Diario';
          break;
        case 'R/P2W':
          periodicityName = 'Quincenal';
          break;
        case 'R/P6M':
          periodicityName = 'Semestral';
          break;
        case 'R/P2Y':
          periodicityName = 'Bienal';
          break;
        case 'R/P3Y':
          periodicityName = 'Trienal';
          break;
        case 'R/P0.33W':
          periodicityName = 'Tres veces por semana';
          break;
        case 'R/P0.33M':
          periodicityName = 'Tres veces al mes';
          break;
        case 'R/PT1S':
          periodicityName = 'Actualizado continuamente';
          break;
        case 'R/P1M':
          periodicityName = 'Mensual';
          break;
        case 'R/P3M':
          periodicityName = 'Trimestral';
          break;
        case 'R/P0.5M':
          periodicityName = 'Quincenal';
          break;
        case 'R/P4M':
          periodicityName = 'Tres veces al año';
          break;
        case 'R/P1W':
          periodicityName = 'Semanal';
          break;
        case 'R/PT1H':
          periodicityName = 'Cada hora';
          break;
        case 'irregular':
          periodicityName = 'irregular';
          break;
        default:
          periodicityName = '-';
          break;
      }

      return periodicityName;
    }
  }

  function themes(theme) {
    if (!theme) {
      return null;
    } else {
      return theme.map((topic) => {
        return (
          <span className="mr-2" title={topic.data}>
            <span className="mr-2">{topic.data}</span>
            <TopicIcon
              title={topic.data}
              height={16}
              width={16}
              color="white"
              key={topic.identifier}
            />
          </span>
        );
      });
    }
  }

  function formats(distribution) {
    if (!distribution) {
      return null;
    }

    if (Array.isArray(distribution)) {
      var newDistribution = distribution.map((dist) => dist.data);
      var distributionWithUniqueFormats = getUniqueFormats(
        Object.entries(newDistribution)
      );

      const counted = countBy(newDistribution, (d) => {
        return d.format;
      });

      return distributionWithUniqueFormats.map(function (dist, idx) {
        var type = dist.mediaType ? dist.mediaType.split('/') : '';
        var backup = type ? type : 'data';
        var format = dist.format ? dist.format : backup;
        var finishIcon = '';
        switch (format.toLowerCase()) {
          case 'pdf':
            finishIcon = 'fa-solid fa-file-pdf';
            break;
          case 'csv':
            finishIcon = 'fa-solid fa-file-csv';
            break;
          case 'zip':
            finishIcon = 'fa-solid fa-file-zipper';
            break;
          case 'json':
            finishIcon = 'fa-solid fa-file-code';
            break;
          case 'tablero':
            finishIcon = 'fa-solid fa-chart-area';
            break;
          case 'html':
            finishIcon = 'fa-brands fa-html5';
            break;
          case 'data':
            finishIcon = 'fa-solid fa-file-archive';
            break;
        }
        return (
          <span key={idx} style={{ marginRight: '1.5rem', display: 'inline-flex', alignItems: 'center' }}>
            <i className={`mr-2 ${finishIcon}`} title={format}></i>
            <span style={{ fontWeight: '600', fontSize: '1.3rem' }}>
              {format.toUpperCase()}
            </span>
            <span
              className="totalFormat"
              key={'total' + idx}
            >{` (x${counted[format]})`}</span>
          </span>
        );
      });
    }

    return null;
  }

  function getUniqueFormats(formats) {
    var unique = [];
    return formats.reduce(function (a, b) {
      if (unique.indexOf(b[1].format) === -1) {
        unique.push(b[1].format);
        a.push(b[1]);
      }
      return a;
    }, []);
  }

  function toogleTechCardVisibility() {
    setDisplay(display === 'none' || display === '' ? 'block' : 'none');
    setIconCardClass(
      iconCardClass === 'fa-chevron-down' ? 'fa-chevron-up' : 'fa-chevron-down'
    );
    setSpanColor(spanColor === '#FA8D2D' ? '#53ACE9' : '#FA8D2D');
    setSpanText(
      spanText === 'Cerrar detalles' ? 'Abrir detalles' : 'Cerrar detalles'
    );
  }

  function goToClose(item) {
    if (
      item &&
      item.theme &&
      Array.isArray(item.theme) &&
      item.theme.length > 0
    ) {
      const theme = item.theme[0];
      window.location.assign(`/search/?theme=${theme.data}`);
    }
  }

  const navigate = useNavigate();
  return (
    <Layout
      title={`Dataset - ${item.title}`}
      headerClass="header header--small"
    >
      {item && item.theme && (
        <Breadcrumb themes={item.theme} curretItem={{ title: item.title }} />
      )}

      <section class="header-section data">
        <div class="data-container">
          <div>
            <p class="title title--black">{item.title}</p>
            <p class="paragraph paragraph--black margin-bottom-sm">
              <Text value={item.description} />
            </p>
          </div>
          <div class="button-close">
            <button
              onClick={() => goToClose(item)}
              style={{ background: 'none', border: 'none' }}
            >
              {' '}
              x{' '}
            </button>
          </div>
        </div>
      </section>

      <section class="data-technical-section">
        <div class="data-technical-info">
          <div class="data-block container">
            <div class="data-technical-info-list row">
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Dependencia:</span> {orgName}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Última modificación:</span> {item.modified || ''}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Formato(s):</span>{' '}
                {item.distribution && formats(item.distribution)}
              </div>
            </div>
            <div class="data-technical-info-list row">
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Categoria:</span>{' '}
                {theme.length > 0 && themes(theme)}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Vistas:</span>{' '}
                {views}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Descargas:</span>{' '}
                {/* {downloads} */}
                {datasetDonwloads}
              </div>
            </div>
          </div>
        </div>

        <div class="data-sheet data-block">
          <div class="data-card">
            <div class="data-card-header">
              <p class="subtitle subtitle--black">
                <b>Ficha técnica</b>
              </p>
              <div onClick={() => toogleTechCardVisibility()}>
                <span
                  class="text"
                  style={{ color: spanColor, marginRight: '10px' }}
                >
                  {' '}
                  {spanText}
                </span>{' '}
                <i id="icon-card" className={`fa-solid ${iconCardClass}`}></i>
              </div>
            </div>
            <div
              id="card-body"
              class="data-card-body"
              style={{ display: display }}
            >
              {/* Ficha técnica en formato vertical: cada campo es una fila
                  (etiqueta + valor), de modo que la información se lea de arriba
                  hacia abajo sin necesidad de desplazamiento horizontal. */}
              <table class="data-table data-table--vertical">
                <tbody>
                  {orgName && (
                    <tr>
                      <th>Dependencias</th>
                      <td>{orgName}</td>
                    </tr>
                  )}
                  {('modified' in item && item.modified) && (
                    <tr>
                      <th>Fecha de modificación</th>
                      <td>{item.modified}</td>
                    </tr>
                  )}
                  {('issued' in item && item.issued) && (
                    <tr>
                      <th>Fecha de publicación</th>
                      <td>{item.issued}</td>
                    </tr>
                  )}
                  {('accrualPeriodicity' in item && item.accrualPeriodicity) && (
                    <tr>
                      <th>Frecuencia</th>
                      <td>{getPeriodicity(item.accrualPeriodicity)}</td>
                    </tr>
                  )}
                  {('identifier' in item && item.identifier) && (
                    <tr>
                      <th>Identificador</th>
                      <td>{item.identifier}</td>
                    </tr>
                  )}
                  {('conformsTo' in item && item.conformsTo) && (
                    <tr>
                      <th>Estándar de datos</th>
                      <td>{item.conformsTo}</td>
                    </tr>
                  )}
                  {('temporal' in item && item.temporal) && (
                    <tr>
                      <th>Cobertura temporal</th>
                      <td>{item.temporal}</td>
                    </tr>
                  )}
                  {/* Licencia oficial del portal (RF11): Creative Commons BY 4.0
                      para todos los datasets, conforme a la Circular Conjunta
                      No. 202660000054 de 2026 del Distrito de Medellín. Se
                      muestra siempre (no depende de item.license) e incluye el
                      enlace a la licencia y la cláusula de indemnidad exigida por
                      la Resolución 1519 de 2020 de MinTIC. */}
                  <tr>
                    <th>Licencia</th>
                    <td>
                      <span className="license-cc">
                        <svg
                          className="license-cc__icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 100 100"
                          width="18"
                          height="18"
                          role="img"
                          aria-label="Creative Commons"
                        >
                          <path
                            fill="currentColor"
                            d="M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 9c22.6 0 41 18.4 41 41S72.6 91 50 91 9 72.6 9 50 27.4 9 50 9zM37.4 32.6c-9.6 0-17.4 7.8-17.4 17.4S27.8 67.4 37.4 67.4c5.9 0 11.1-2.9 14.3-7.4l-6.6-3.4c-1.7 2.4-4.5 3.9-7.7 3.9-5.3 0-9.6-4.3-9.6-9.5s4.3-9.5 9.6-9.5c3.2 0 6 1.5 7.7 3.9l6.6-3.4c-3.2-4.5-8.4-7.4-14.3-7.4zm32.3 0c-9.6 0-17.4 7.8-17.4 17.4s7.8 17.4 17.4 17.4c5.9 0 11.1-2.9 14.3-7.4l-6.6-3.4c-1.7 2.4-4.5 3.9-7.7 3.9-5.3 0-9.6-4.3-9.6-9.5s4.3-9.5 9.6-9.5c3.2 0 6 1.5 7.7 3.9l6.6-3.4c-3.2-4.5-8.4-7.4-14.3-7.4z"
                          />
                        </svg>
                        <a
                          href="https://creativecommons.org/licenses/by/4.0/deed.es"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Atribución 4.0 Internacional (CC BY 4.0)
                        </a>
                      </span>
                      <p className="license-disclaimer">
                        La Alcaldía de Medellín no será responsable por la
                        utilización, tratamiento, transformación de los datos, ni
                        tampoco, sobre cualquier tipo de responsabilidad legal o
                        económica sobre el uso directo o indirecto que se realice
                        sobre estos datos.
                      </p>
                    </td>
                  </tr>
                  {('contactPoint' in item && item.contactPoint && item.contactPoint.fn) && (
                    <tr>
                      <th>Contacto</th>
                      <td>{item.contactPoint.fn}</td>
                    </tr>
                  )}
                  {('contactPoint' in item && item.contactPoint && item.contactPoint.hasEmail) && (
                    <tr>
                      <th>Email de contacto</th>
                      <td>{item.contactPoint.hasEmail}</td>
                    </tr>
                  )}
                  {('accessLevel' in item && item.accessLevel) && (
                    <tr>
                      <th>Nivel de acceso</th>
                      <td>{item.accessLevel === 'public' ? 'Público' : item.accessLevel}</td>
                    </tr>
                  )}
                  {('describedBy' in item && item.describedBy) && (
                    <tr>
                      <th>Metadata adicional</th>
                      <td>
                        <a href={item.describedBy} target="_blank" rel="noopener noreferrer" title="Ver metadata adicional">
                          {item.describedBy}
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="data-view">
          <div class="data-card">
            <div class="data-card-header">
              <p class="subtitle subtitle--black">
                <b>Vista previa</b>
              </p>
            </div>
            <div class="data-card-body">
              {Object.keys(item).length ? (
                <div>
                  {hasWindow &&
                    item.distribution &&
                    item.distribution.filter((dist) => dist.data.format.toLowerCase() == 'csv').map((dist, i) => {
                      if (i == 0) {
                        return (
                          <div key={dist.identifier}>
                            {/* Selector multi-formato integrado - solo si hay múltiples distribuciones */}
                            {item.distribution.length > 1 && (
                              <div className='containerResource'>
                                <p className='subtitle subtitle--black'><b>Descargar conjunto de datos</b></p>
                                <FileDownloadMultiFormat
                                  title="Descargar"
                                  distributions={item.distribution}
                                  id={id}
                                />
                              </div>
                            )}
                            {/* Vista previa del CSV - ocultar botones si hay selector multi-formato */}
                            <ResourceTemplate
                              resource={dist}
                              identifier={dist.identifier}
                              id={id}
                              hideButtons={item.distribution.length > 1}
                            />
                          </div>
                        );
                      } else {
                        return (
                          <>
                            <div className='containerResource'>
                              <p className='subtitle subtitle--black'><b>{dist.data.title}</b></p>
                              <div className='containerResourceButtons'>
                                <FileDownload
                                  title={'Descargar'}
                                  label={'Descargar'}
                                  format={dist.data.format}
                                  downloadURL={dist.data.downloadURL ? dist.data.downloadURL : dist.data.accessURL}
                                  id={id}
                                />
                                <div className='data-actions pl-2'>
                                  <a href={`/resource/${dist.identifier}`} title="Ver" className='button button-secondary' target='_blank'>
                                    <i className='fa-solid fa-eye' />
                                    {` Visualizar`}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <hr />
                          </>
                        )
                      }
                    })
                  }
                  {hasWindow &&
                    item.distribution &&
                    item.distribution.filter((dist) => dist.data.format.toLowerCase() != 'csv').map((dist) => {
                      return (
                        <ResourceTemplate
                          key={dist.identifier}
                          resource={dist}
                          identifier={dist.identifier}
                          id={id}
                        />
                      );
                    })

                  }
                  <Tags tags={tag} path="/search/?keyword=" label="Etiquetas" />
                  <hr />
                  <p>
                    La información de esta página también está disponible vía{' '}
                    <Link
                      to={`/dataset/${item.identifier}/api`}
                      state={{ dataset: { ...item } }}
                    >
                      API
                    </Link>
                  </p>
                  <Share url={url} />
                </div>
              ) : (
                <div className="row">
                  <Spinner color="primary" />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <Subscription id={id} /> */}
        <section className="newsletter-section">
          <div className="container-home">
            <HomeSurvey />
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Dataset;
